import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppContextProvider } from '@context';
import useDeviceDetect from '@hooks/useDeviceDetect';
import Router from '../Router';
import GlobalStyles from '../styles';

const queryClient = new QueryClient();

function Root() {
  const { isMobile } = useDeviceDetect();
  const fallbackRender = (): JSX.Element => null;

  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <ThemeProvider theme={dsTokens}>
          <ErrorBoundary fallbackRender={fallbackRender}>
            <GlobalStyles />
            <Router isMobile={isMobile} />
          </ErrorBoundary>
        </ThemeProvider>
      </AppContextProvider>
    </QueryClientProvider>
  );
}

export default Root;
